import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Record } from './record';
import { RecordService } from './record.service';
import { DossierModel } from '../dossier-model/dossier-model';
import { NotifierService } from '../ui';
import { RecordLink } from '../record-link/record-link';

type ViewMode = 'view';

@Component({
  templateUrl: './record-edit.component.html',
})
export class RecordEditComponent implements OnInit {

  record: Record
  dossierModel: DossierModel

  mode: ViewMode
  title: string

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private recordService: RecordService,
    private notifier: NotifierService
  ) { }

  ngOnInit() {

    this.mode = this.route.routeConfig.data.mode;
    this.title = this.route.routeConfig.data.title;

    switch (this.mode) {
      case 'view':
        {
          // Get the record
          this.notifier.startProgress();

          this.route.data.subscribe((data) => {
            this.record = data.record;
            this.dossierModel = data.dossierModel;

            this.notifier.endProgress();
          });
        }
        break;
    }
  }

  showDossier(link: RecordLink) {
    this.router.navigate(['dossiers', link.dossier.id]);
  }
}
